import { Directive, ElementRef, HostListener } from "@angular/core";

@Directive({
  selector: "[appOnlyNumber]",
  standalone: false,
})
export class OnlyNumberDirective {
  @HostListener("keydown", ["$event"])
  onKeyDown(event: KeyboardEvent) {
    // Allow control keys
    if (
      event.key === "Backspace" ||
      event.key === "Tab" ||
      event.key === "ArrowLeft" ||
      event.key === "ArrowRight"
    ) {
      return;
    }

    // Allow only numbers
    if (!/^[0-9]$/.test(event.key)) {
      event.preventDefault();
    }
  }
}
